import PartnerView from "./PartnerView";

export default PartnerView;
